'use strict';

import type { UserPersonalToken } from '../../Entities/User/UserPersonalToken';
import { EntityCollection } from '../EntityCollection';

export class UserPersonalTokenCollection extends EntityCollection<UserPersonalToken> {}
